export const environment = {
  projectId: '1f2dab3e-4b3e-4085-a2a2-fd0e64deb690',
  // apiBaseUrl: 'https://20197491-0906-4f36-8ce4-c5fa9d1e22d7.api.rappider.com',
  apiBaseUrl: 'https://1f2dab3e-4b3e-4085-a2a2-fd0e64deb690.api.rapider.ai',
  production: false,
  PROJECT_ID: '1f2dab3e-4b3e-4085-a2a2-fd0e64deb690',
  RAPIDER_AI_API_BASE_URL: 'https://api.rapider.ai',
  DESCOPE_PROJECT_ID: null,
  STAGE: 'DEV',
};
